import { render } from "./ComingSoonComponent.vue?vue&type=template&id=218647f8&scoped=true"
import script from "./ComingSoonComponent.vue?vue&type=script&lang=js"
export * from "./ComingSoonComponent.vue?vue&type=script&lang=js"

import "./ComingSoonComponent.vue?vue&type=style&index=0&id=218647f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218647f8"]])

export default __exports__